import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  paper: {
    width: '100%',
    display: 'flex',
    flexFlow: 'column',
    padding: [theme.spacing(2), theme.spacing(2), 0],
    [theme.breakpoints.up('mobile')]: {
      minWidth: 800,
      maxWidth: 800,
    },
  },
  header: {
    padding: [theme.spacing(2), 0, theme.spacing(4)],
    color: theme.palette.colors.darkBlue,
    borderBottom: [1, 'solid', theme.palette.colors.divider],
  },
  select: {
    width: '100%',
  },
  informer: {
    display: 'flex',
    padding: [theme.spacing(1)],
    marginTop: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    backgroundColor: theme.palette.colors.warning,
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/LoanOfficerSelect/useStyles.js